document.addEventListener('DOMContentLoaded', () => {
  const bunny = document.getElementById('kit-club-bunny');

  if (!bunny) return;

  const finePointer = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
  ).matches;

  if (!finePointer) return;

  let mouseX = -100;
  let mouseY = -100;
  let bunnyX = -100;
  let bunnyY = -100;

  let isHopping = false;
  let animationFrame = null;

  function animate() {
    bunnyX += (mouseX - bunnyX) * 0.16;
    bunnyY += (mouseY - bunnyY) * 0.16;

    const hopOffset = isHopping ? -10 : 0;

    bunny.style.transform =
      `translate3d(${bunnyX + 12}px, ${bunnyY + 12 + hopOffset}px, 0)`;

    const distanceX = Math.abs(mouseX - bunnyX);
    const distanceY = Math.abs(mouseY - bunnyY);

    if (distanceX > 0.2 || distanceY > 0.2 || isHopping) {
      animationFrame = requestAnimationFrame(animate);
    } else {
      animationFrame = null;
    }
  }

  function startAnimation() {
    if (animationFrame === null) {
      animationFrame = requestAnimationFrame(animate);
    }
  }

  function hop() {
    if (isHopping) return;

    isHopping = true;
    bunny.classList.add('is-hopping');

    startAnimation();

    window.setTimeout(() => {
      isHopping = false;
      bunny.classList.remove('is-hopping');
    }, 300);
  }

  document.addEventListener(
    'mousemove',
    (event) => {
      mouseX = event.clientX;
      mouseY = event.clientY;

      bunny.classList.add('is-visible');

      startAnimation();
    },
    { passive: true }
  );

  document.addEventListener('mouseleave', () => {
    bunny.classList.remove('is-visible');
  });

  const hoverTargets = [
    'a',
    'button',
    '.button',
    '.card-wrapper',
    '.product-card-wrapper',
    '.header__menu-item',
    '.header__icon'
  ].join(',');

  document.addEventListener('mouseover', (event) => {
    const target = event.target.closest(hoverTargets);

    if (!target) return;

    bunny.classList.add('is-hovering');
    hop();
  });

  document.addEventListener('mouseout', (event) => {
    const target = event.target.closest(hoverTargets);

    if (!target) return;

    bunny.classList.remove('is-hovering');
  });
});